import React from 'react';
import { styled } from '@mui/system';
import Text from '../../../../components/Text.js';
import Tooltip from '../../../../components/Tooltip.js';
import { colors } from '../../../../theme/index.js';

/**
 * @param data
 * @param selected
 * @param onSelect
 * @param classes
 * @param id
 * @returns {*}
 * @constructor
 */
const DivisionListItem = ({
  data,
  selected,
  onSelect,
  id,
  testid
}) => {
  const DivisionCard = styled("div")(({
    theme
  }) => ({
    '&:hover': {
      borderLeft: `${theme.palette.primary.main} solid 5px`
    },
    backgroundColor: selected ? theme.palette.primary.light : colors.surface,
    borderLeft: selected ? `${theme.palette.primary.main} solid 5px` : `${colors.surface} solid 5px`,
    boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
    cursor: 'pointer',
    marginBottom: '0',
    padding: '10px 10px 7px 8px',
    position: 'relative',
    width: '100%',
    overflow: 'hidden'
  }));
  return /*#__PURE__*/React.createElement(DivisionCard, {
    id: id || testid,
    onClick: onSelect
  }, data.description ? /*#__PURE__*/React.createElement(Tooltip, {
    tip: data.description,
    placement: "top-start"
  }, /*#__PURE__*/React.createElement(Text, {
    align: "center",
    color: "inherit",
    medium: true,
    display: "inline"
  }, data.title)) : /*#__PURE__*/React.createElement(Text, {
    align: "center",
    color: "inherit",
    medium: true,
    display: "inline"
  }, data.title));
};
export default DivisionListItem;